import { types } from 'mobx-state-tree';

import { ContactTimes, UserPurposeValues, HomeCoverage } from '../definitions/InsCommon';
import { partiallyUpdateModel } from '../definitions/Common';
import Property from './Property';
import Occupant from './Occupant';
import Construction from './Construction';
import Applicant from './Applicant';
import OtherInformation from './OtherInformation';


export default types
    .model('Application', {
        applicant: types.maybeNull(Applicant),
        
        // With V9, remove email & phone and
        //  rely on Applicant for it
        email: types.maybeNull(types.string),
        phone: types.maybeNull(types.string),
        
        newsletterSignupConsent: types.maybeNull(types.boolean),
        wantsToBundleInsurance: types.maybeNull(types.boolean),
        creditCheckConsent: types.maybeNull(types.boolean),
        contactTime: types.optional(
            types.enumeration(Object.values(ContactTimes)),
            ContactTimes.ANYTIME,
        ),

        userPurpose: types.maybeNull(
            types.enumeration(Object.values(UserPurposeValues)),
        ),

        property: types.maybeNull(Property),
        occupant: types.maybeNull(Occupant),
        otherInformation: types.maybe(OtherInformation),
        construction: types.maybeNull(Construction),
        coverage: types.maybeNull(HomeCoverage),
    })
    .views(self => ({
        get isValid() {
            return (
                self.property?.isValid
                && self.occupant?.isValid
                && self.otherInformation?.isValid
                && self.construction?.isValid
                && self.email != null
                && self.phone != null
                && self.newsletterSignupConsent != null
                && self.wantsToBundleInsurance != null
                && self.creditCheckConsent != null
            );
        },
    }))
    .actions(self => ({
        update(value) {
            partiallyUpdateModel(self, value);
        },
        updateUserLanguage(language) {
            self.applicant = {
                ...self.applicant,
                contact: {
                    ...self.applicant?.contact,
                    language,
                },
            };
        },
    }));
